import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { StompSessionProvider } from 'react-stomp-hooks';

import { GlobalStyles } from '@mui/material';

// routes
import Routes from './routes';
// theme
import ThemeProvider from './theme';
import { AuthProvider } from './hooks/useAuth';
import IdleLogout from './hooks/useIdleLogout';
// components
import { StyledChart } from './components/chart';
import { ModalProvider } from './hooks/useModal';
import { SnackbarProvider } from './hooks/useToast';
import ScrollToTop from './components/scroll-to-top';
import PermissionSyncListener from './hooks/PermissionSyncListener';
// ----------------------------------------------------------------------

export default function App() {
  const API_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:8081'}/ws`;

  return (
    <HelmetProvider>
      <BrowserRouter>
        <ThemeProvider>
          <ScrollToTop />
          <StyledChart />
          <GlobalStyles
            styles={(theme) => ({
              // Targets all autofill states (normal, hover, focus, active)
              'input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active':
                {
                  // Paints over the blue highlight with the theme's background paper color
                  WebkitBoxShadow: `0 0 0 1000px ${theme.palette.background.paper} inset !important`,
                  // Forces the text to use the theme's primary text color
                  WebkitTextFillColor: `${theme.palette.text.primary} !important`,
                  transition: 'background-color 5000s ease-in-out 0s',
                },
            })}
          />
          <AuthProvider>
            <SnackbarProvider>
              <ModalProvider>
                <IdleLogout>
                  <StompSessionProvider url={API_URL}>
                    <PermissionSyncListener />
                    <Routes />
                  </StompSessionProvider>
                </IdleLogout>
              </ModalProvider>
            </SnackbarProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}
